import {
	Component,
	OnInit,
	ChangeDetectionStrategy,
	ElementRef,
	ViewChild,
	Input,
	AfterViewInit,
	OnChanges
} from '@angular/core';
import { ApiService } from '@services/api.service';

const canvasWrapper = 'canvasWrapper';
const contentNode = 'content';

@Component({
	selector: 'bar-code',
	template: `<div class="h" #${contentNode}><ng-content></ng-content></div>
		<div class="w" #${canvasWrapper}></div>`,
	styles: [
		`
			.h {
				display: none;
			}
		`
	]
})
export class BarcodeComponent implements OnInit, OnChanges {
	private _currentlyEncodedValue!: string;

	@ViewChild(contentNode, { read: ElementRef, static: true })
	contentRef: ElementRef<HTMLElement>;

	@ViewChild(canvasWrapper, { read: ElementRef, static: true })
	targetRef: ElementRef<HTMLElement>;

	@Input() set config(cfg) {
		this._render(this._currentlyEncodedValue);
	}

	@Input()
	text = null;

	constructor(private _api: ApiService) {}

	ngOnInit(): void {}

	ngAfterViewInit() {}

	ngOnChanges() {
		if (this.text) {
			const cur = this._currentlyEncodedValue;
			const inc = this.contentRef.nativeElement?.innerText;
			if (cur !== inc) {
				this._render(this.text);
			}
		}
	}

	private _render(value: string) {
		const t = this.targetRef.nativeElement;
		t.innerHTML = '';
		console.log('config', this.config);
		if (value) {
			const canvas: HTMLCanvasElement = (
				this._api as any
			).barcode.toCanvas(value);

			const img = new Image();
			img.src = canvas.toDataURL();
			img.width = 300;

			this.targetRef.nativeElement.appendChild(img);
			this._currentlyEncodedValue = value;
		}
	}
}
